export enum SelectionMode {
  None = 'none',
  New = 'new',
  Existing = 'existing',
}

export interface SaveProjectDto {
  rigSelection: SelectionMode;
  rigName: string | null;
  rigAlias: string | null;
  rigId: number | null;

  wellSelection: SelectionMode;
  wellName: string | null;
  prospectName: string | null;
  prospectNumber: string | null;
  field: string | null;
  blockNumber: string | null;
  api: string | null;
  chevNo: string | null;
  mudSupplierId: number | null;
  cementSupplierId: number | null;
  wellId: number | null;

  projectName: string | null;
  businessUnitId: number;
  isTurnKey: boolean;
  initiatorsCai: string | null;
  sapCode: string | null;
}
